import React from 'react';
import './Modal.css';
import visitProfileIcon from "../../assets/images/visitprofile.svg"
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';

const VisitProfileModal = ({ isVisible, onClose, onConfirm, isLoading }) => {
    return (
        isVisible && (
            <div className="modal-backdrop">
                <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                    <div className='content-container'>
                        <div className='icon-container'>
                            <img src={visitProfileIcon} />
                        </div>
                        <div className='text-container'>
                            <Heading6Semibold color='#1E293B' text='Visit Profile' />
                            <BodyMediumRegular
                                color='#384153'
                                text='By changing visit profile, all the added events will be discarded, are you sure you want to continue?'
                                textAlign='center'
                            />
                        </div>
                    </div>
                    <div className='button-contiainer'>
                        <button className='cancel-button'
                            onClick={onClose}
                        >
                            <BodyExtraSmallMedium color='#1E293B' text='Cancel' />
                        </button>
                        <button className='primary-button' onClick={onConfirm} disabled={isLoading}>
                            <BodyExtraSmallMedium color='#FFFFFF' text='Yes' />
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default VisitProfileModal;